/**
 * Created by calhosh on 7/20/2023
 */
import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../../../../../../util/utils';

export default function NoRowsOverlay() {
	return (
		<StyledNoRowsOverlay className="StyledOARNoRowsOverlay">
			<span className="helixSetURLText">{labels.noClientDataAvailable}</span>
		</StyledNoRowsOverlay>
	);
}

const StyledNoRowsOverlay = styled.section`
	font-size: var(--px-14);
	font-weight: 400;
	line-height: var(--px-22);
	color: var(--neutrals-700);
	.helixSetURL {
		font-weight: 700;
		color: var(--blue-600);
		cursor: pointer;
		pointer-events: all;
		&:hover {
			text-decoration: underline !important;
		}
	}
`;
